import React from "react";
import { autobind } from "react-decoration";
import qs from "query-string";

import Pagination from "./Pagination";
import { navigate } from "gatsby";
import withLocation from "lib/withLocation";
import ReactHtmlParser from "react-html-parser";
import { Interpolate } from "react-i18next";

@withLocation
class NormalPagination extends Pagination {
  constructor(props) {
    super(props);
    this.state = {
      info: {
        nowpage: Math.ceil(props.start / props.limit) + 1, //props.startPageNo
        nextpage: false,
        lastpage:
          props.pageNo < props.totalPage || props.pageNo < props.totalPage,
      },
    };
  }

  componentWillReceiveProps(props) {
    this.setState(props);
  }

  @autobind
  changePageSize(e) {
    let { search, location } = this.props;

    let params = { ...search, limit: e.target.value };
    delete params["pageNo"];
    navigate([location.pathname, qs.stringify(params)].join("?"));
  }

  render() {
    const { nowpage, lastpage: isLastpage } = this.state.info;
    const {
      t,
      totalPage,
      pages,
      total,
      goPage,
      showNext,
      showPrevious,
      limit,
      showpage,
      hasFilter,
      nFilterTotal,
    } = this.props;
    let prevPage = Math.max(1, nowpage - 1);

    if (totalPage == 0) {
      return null;
    }

    return (
      <>
        <section className="pagination expansion">
          <ul className="page">
            <li className="first">
              <a
                href="javascript:;"
                tabIndex="0"
                title={t`jumperrwd.common.firstPage`}
                onClick={() => goPage(1)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    goPage(1);
                  }
                }}>
                {t`jumperrwd.common.firstPage` + " "}
              </a>
            </li>
            {showPrevious && (
              <li className="prev">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  onClick={() => goPage(prevPage)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(prevPage);
                    }
                  }}
                  title={t`jumperrwd.common.prevPage`}>
                  {t`jumperrwd.common.prevPage` + " "}
                </a>
              </li>
            )}
            {pages.map((page, key) => {
              return (
                <li key={`page_${key}`} className={page.active ? "active" : ""}>
                  <a
                    href="javascript:;"
                    tabIndex="0"
                    onClick={() => goPage(page.val)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        goPage(page.val);
                      }
                    }}>
                    {page.val}
                  </a>
                </li>
              );
            })}
            {showNext && (
              <li className="next">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  title={t`jumperrwd.common.nextPage`}
                  onClick={() => goPage(nowpage + 1)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(nowpage + 1);
                    }
                  }}>
                  {t`jumperrwd.common.nextPage` + " "}
                </a>
              </li>
            )}
            {isLastpage && (
              <li className="last">
                <a
                  href="javascript:;"
                  tabIndex="0"
                  title={t`jumperrwd.common.lastPage`}
                  onClick={() => goPage(totalPage)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      goPage(totalPage);
                    }
                  }}>
                  {t`jumperrwd.common.lastPage` + " "}
                </a>
              </li>
            )}
          </ul>
          <form action="" className="form_inline">
            <div className="total">
              {hasFilter ? (
                <>
                  {ReactHtmlParser(
                    t("jumperrwd.list.filterTotalAmountWithPage", {
                      total: total,
                      filterTotal: nFilterTotal,
                      nowPage: nowpage,
                      totalPage: totalPage,
                    })
                  )}
                </>
              ) : (
                <>
                  {ReactHtmlParser(
                    t("jumperrwd.list.totalAmountWithPage", {
                      total: total,
                      nowPage: nowpage,
                      totalPage: totalPage,
                    })
                  )}
                </>
              )}
              {showpage && (
                <>
                  {" "}
                  <Interpolate
                    t={t}
                    i18nKey="jumperrwd.list.pageSelect"
                    parent={"limit"}
                    pageSelect={
                      <>
                        <select
                          onChange={this.changePageSize}
                          title="頁數"
                          defaultValue={limit}>
                          {showpage.map((item, key) => {
                            return (
                              <option key={`pagesize_${key}`} value={item}>
                                {item}
                              </option>
                            );
                          })}
                        </select>
                      </>
                    }
                  />
                </>
              )}
            </div>
          </form>
        </section>
      </>
    );
  }
}

export default NormalPagination;
